import React, { Component } from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import Login from './components/Login/Login'
import Logout from './components/Logout/Logout'
import ForgotPassword from './components/Forgot-password/Forgot-password';
import ResetPassword from './components/Reset-password/Reset-password';
import Layout from './components/Layout/Layout'
import { connect } from 'react-redux'
import { authCheckState, setAuthRedirectPath } from './actions';


class App extends Component {
    componentDidMount () {
        this.props.tryAutoSignin();
    }

    render() {
        let route;
        if (this.props.isAuthenticated) {
            route = (
                <Switch>
                  <Route path="/logout" exact component={Logout} />
                  <Route path="/forgot" exact component={ForgotPassword} />
                  <Route path="/reset" exact component={ResetPassword} />
                  <Route path="/login" component={ Login } />
                  <Route path="/" component={Layout} />

                </Switch>
            );
        } else {
            if (this.props.location.pathname !== '/login') {
                this.props.setAuthRedirectPath(this.props.location.pathname);
            }

            route = (
                <Switch>
                  <Route path="/login" component={ Login } />
                  <Route path="/forgot" component={ ForgotPassword } />
                  <Route path="/reset" component={ ResetPassword } />
                  <Redirect to="/login" />
                </Switch>
            );
        }

        return (
            <div>
                { route }
            </div>
        );

    }
}


const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.token !== null
    };
};

const mapDispatchToProps = dispatch => {
    return {
        tryAutoSignin: () => dispatch( authCheckState() ),
        setAuthRedirectPath: path => dispatch( setAuthRedirectPath(path) )
    };
};

export default withRouter( connect(mapStateToProps, mapDispatchToProps)( App ) );



// WEBPACK FOOTER //
// ./src/App.js